<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink">
    <visibility-flags :project="project"></visibility-flags>
    <milestone-progress v-if="showMilestoneCount" :milestonePostCount="project.milestonePostCount" :completedPostCount="project.completedPostCount"/>
    <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :projectAwards="project.awards" :imageOverlay="imageOverlay"/>
    <project-title v-if="$isIsef" :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" />
    <information v-if="$isIsef" :isRowLoading="isRowLoading" :isBlank="isBlank">
      <owners :members="coOwners"/>
    </information>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import CategoryCircles from '../UI/Category.vue'
import ProjectImage from '../UI/ProjectImage'
import User from '../UI/User'
import VisibilityFlags from '@/components/Cards/ProjectCards/UI/visibilityFlags'
import MilestoneProgress from '../UI/MilestoneProgress'
import Owners from '../UI/Isef/Owners'
export default {
  name: 'Project',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    User,
    CategoryCircles,
    VisibilityFlags,
    MilestoneProgress,
    Owners
  },
  props: ['projectID', 'categoryID', 'storyType', 'isMarginless', 'isRowLoading', 'isPinnableRow', 'pinnedProjects', 'disableLink'],
  mixins: [base, visibility],
  computed: {
    showCategories: function () {
      return this.$isYSC || this.$isMake
    },
    showMilestoneCount: function () {
      return this.project.milestonePostCount && this.project.milestonePostCount !== 0 && !this.isOASJudge && (this.$route.fullPath === '/viewAll/?profile=mine' || this.$route.name === 'profile')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
::v-deep .main-container .story-title {
  height: 44px;
  @include mobile {
    height: 40px;
  }
}
.owners {
  padding: 0 1rem;
  font-family: 'Helvetica Neue';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #848589;
}
</style>
